import React, { useEffect } from 'react';
import * as luxon from 'luxon';
import { Typography } from '@material-ui/core';
import ReactCountDown, { calcTimeDelta } from 'react-countdown';
/**
 * カウントダウンコンポーネント
 * react-countdownライブラリを使用
 * @param now サーバーの現在時刻
 * @param usedAt サーバーの使用した日付
 * @param countDownMinute クーポンマスタのカウントダウン分数
 * @param className クラス名
 * @param setComplete カウントダウンが終了したか
 */
export var CountDown = function (_a) {
    var now = _a.now, usedAt = _a.usedAt, countDownMinute = _a.countDownMinute, className = _a.className, setComplete = _a.setComplete;
    var nowMillis = luxon.DateTime.fromISO(now).toMillis();
    var usedAtDateTime = luxon.DateTime.fromISO(usedAt);
    // レンダリング関数は即時渡されるため、Reactのライフサイクルを無視してしまう
    // renderer の中で setState すると
    // Warning: Cannot update a component (`SmartCheckDisplayPreview`) while rendering a different component (`Countdown$1`). To locate the bad setState() call inside `Countdown$1`, follow the stack trace as described
    // となる。なので少し回りくどいがマウント時にfalseになる状態をウォッチする変数を用意しておき
    // その変数の変化によってsetCompleteする
    var _completed = false;
    useEffect(function () {
        if (_completed)
            setComplete(true);
    }, [_completed, setComplete]);
    // 使用済日付から countDownMinute を+した日付がカウントダウン終了日付となる
    var closingDateTime = usedAtDateTime.plus({ minutes: Number(countDownMinute) });
    // サーバーの現在時刻から、終了日付の差分時間を取得する
    var timeDelta = calcTimeDelta(closingDateTime.toJSDate(), {
        now: function () { return nowMillis; },
    });
    var renderer = function (_a) {
        var minutes = _a.minutes, seconds = _a.seconds, completed = _a.completed;
        // カウントダウン分が設定されていない場合
        if (!countDownMinute) {
            return (React.createElement(Typography, { className: className, variant: "h3" }, "\u3053\u306E\u30AF\u30FC\u30DD\u30F3\u306F\u4F7F\u7528\u6E08\u307F\u3067\u3059"));
        }
        // カウントダウン後や強制カウントダウン発動時は onComplete が発火しない
        // 代わりにレンダリング関数の complete フラグが立つのでこれで完了にする
        // 残り時間などは表示しないので空とする
        if (completed) {
            _completed = true;
            return React.createElement(React.Fragment, null);
        }
        // カウントダウン中
        return (React.createElement(Typography, { className: className, variant: "h3" },
            "\u6B8B\u308A\uFF1A",
            minutes,
            "\u5206",
            seconds,
            "\u79D2"));
    };
    // 現在時刻から何分後に終了するかを指定する
    return (React.createElement(ReactCountDown
    // コンポーネント定義で usedAtDateTime.toMillis() を設定することにより、
    // 別の消込試行状態がリセットされる
    // 一方同じ消込（usedAtDateTime）では状態が維持される
    // プレビューで同じ `ReactCountDown` を使いまわしつつ
    // 利用画面で毎度新品の `ReactCountDown` とするにはこれがよさそうだ
    // https://github.com/ndresx/react-countdown#key
    , { 
        // コンポーネント定義で usedAtDateTime.toMillis() を設定することにより、
        // 別の消込試行状態がリセットされる
        // 一方同じ消込（usedAtDateTime）では状態が維持される
        // プレビューで同じ `ReactCountDown` を使いまわしつつ
        // 利用画面で毎度新品の `ReactCountDown` とするにはこれがよさそうだ
        // https://github.com/ndresx/react-countdown#key
        key: usedAtDateTime.toMillis(), date: nowMillis + timeDelta.total, renderer: renderer, onComplete: function () { return setComplete(true); } }));
};
//# sourceMappingURL=CountDown.js.map